import { useEffect, useState } from "react"
import { useFileDownload, usePresignedDownloadUrl } from "./downloadFIle.hook"
import { useMessage } from "hooks/message.hook"
import { removeApiVersion } from "helpers/utils.helper"
import type { TStopPropagation } from "types/default.type"

type TDownloadData = {
	fileName: string
	downloadLink: string
	type: string
}

export const useDocumentDownload = () => {
	const [downloadData, setDownloadData] = useState<TDownloadData>({
		fileName: "",
		downloadLink: "",
		type: "",
	})

	const { downloadFile } = useFileDownload()
	const { error: errorMessage } = useMessage()
	const { refetch: refetchDownload } = usePresignedDownloadUrl(downloadData.downloadLink)

	// Effect for downloading files when downloadData changes
	useEffect(() => {
		if (downloadData.downloadLink) {
			refetchDownload()
				.then((result) => {
					if (result.isSuccess && result.data) {
						const downloadUrl = result.data.download_url
						// Use the presigned URL for downloading the file
						downloadFile(downloadUrl, downloadData.fileName, downloadData.type).catch((e) => {
							if (e) errorMessage("Something went wrong, please try again later")
						})
						setDownloadData({ downloadLink: "", fileName: "", type: "" })
					}
				})
				.catch(() => {
					errorMessage("Something went wrong, please try again later")
				})
		}
	}, [downloadData, refetchDownload, downloadFile, errorMessage])

	// Handles setting document data for download
	const downloadHandle = (fileName: string, downloadLink: string, type: string, e?: TStopPropagation) => {
		e?.stopPropagation()
		const cleanLink = removeApiVersion(downloadLink)
		setDownloadData({ downloadLink: cleanLink, fileName, type })
	}

	return { downloadHandle }
}
